import React, { useState } from "react";
import SpecialtyDropdown from "../shared/SpecialtyDropdown";
import useUserStore from "../../utils/storeApp";
import CallAPI from "../../services/apiCalls";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import { stateCodeArray } from "../../services/fakeDB/ListUser";

const mdl = {
  UserId: null,
  OrganizationId: null,
  OrganizationKind: "",
  DirectorySource: "All",
  DirectoryType: "Providers",
  SearchByName: null,
  FirstName: null,
  LastName: null,
  OrganizationName: null,
  NationalProviderID: null,
  ContactEmail: null,
  DirectEmail: null,
  Address: null,
  City: null,
  Zip: null,
  SpecialitySpecialization: null,
  DomainName: null,
  Resultsize: 0,
};
const AdvSearch = () => {
  const navigate = useNavigate();
  const { SetSharedObject, userRole, userToken, sharedObject } = useUserStore(
    (state) => ({
      SetSharedObject: state.SetSharedObject,
      userRole: state.userRole,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
    })
  );
  const [errDetailFlag, SetErrDetailFlag] = useState(false);
  const [errDetailMsg, SetErrDetailsMsg] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [answers, setAnswers] = useState(mdl);
  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const AdvSearchFunc = async () => {
    let obj = answers;
    if (answers.DirectoryType === "Organizations") {
      obj = {
        ...answers,
        FullName: null,
        OrganizationName: answers.FullName,
      };
    }
    setProcessing(true);
    let call = "/directorySearch/Search";
    const res = await CallAPI(call, obj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      const temp = [];
      for (let el of res.data.data.pageItems) {
        el.DirectoryType = answers.DirectoryType;
        temp.push(el);
      }
      await SetSharedObject("AdvSearchObj", temp);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };
  const SpecialFormFields = async (val) => {
    await setAnswers({
      ...answers,
      SpecialityType: val?.Type,
      SpecialityCLassification: val?.CLassification,
      SpecializationCode: val?.Specialization,
    });
  };
  return (
    <div className="AdvSearch">
      <div
        className="modal fade"
        id="advDirSearchModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="AdvancedDirSearch"
        aria-hidden="false"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title spacer-inline" id="myModalLabel">
                {" "}
                Advanced Search{" "}
              </div>
              <button
                type="button"
                className="close"
                aria-label="Close"
                data-dismiss="modal"
              >
                {" "}
                <span aria-hidden="false">&times;</span>{" "}
              </button>
            </div>

            <form>
              <div className="modal-body">
                <div className="modal-content-body container">
                  {/*NPI*/}
                  <div className="field-wrapper">
                    <label for="npi">NPI</label>
                    <input
                      type="text"
                      className="form-control"
                      value={answers.NationalProviderID}
                      onChange={(el) => {
                        setAnswer("NationalProviderID", el.target.value);
                      }}
                    />
                  </div>
                  {/*Directories to Search Begnins */}
                  <div className="field-wrapper">
                    <div className="spacer-margin5 spacer-inline w-md2">
                      <label for="DirSearch">Directory to Search</label>
                      <select
                        className="form-control"
                        id="DirectorySource"
                        name="DirectorySource"
                        value={answers.DirectorySource}
                        onChange={(el) => {
                          setAnswer("DirectorySource", el.target.value);
                        }}
                      >
                        <option value="All">All</option>
                        <option value="Local">Local</option>
                      </select>
                    </div>
                    <div className="spacer-inline w-md2">
                      <label for="DirType">Directory Type</label>
                      <select
                        className="form-control"
                        id="DirectoryType"
                        name="DirectoryType"
                        value={answers.DirectoryType}
                        onChange={(el) => {
                          setAnswer("DirectoryType", el.target.value);
                        }}
                      >
                        <option value="Providers">Provider</option>
                        <option value="Organizations">Organization</option>
                      </select>
                    </div>
                  </div>

                  {answers.DirectoryType === "Organizations" ? (
                    <div className="field-wrapper">
                      <label for="OrgType">Organization Type</label>
                      <select
                        className="form-control"
                        id="OrganizationKind"
                        name="OrganizationKind"
                        value={answers.OrganizationKind}
                        onChange={(el) => {
                          setAnswer("OrganizationKind", el.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {sharedObject?.getOrgKinds?.map((el) => (
                          <option key={el.id} value={el.description}>
                            {el.description}
                          </option>
                        ))}
                      </select>
                    </div>
                  ) : null}

                  {/*Name*/}
                  <div className="field-wrapper">
                    <label for="Name">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={answers.FullName}
                      onChange={(el) => {
                        setAnswer("FullName", el.target.value);
                      }}
                    />
                  </div>
                  {/*Email*/}
                  <div className="field-wrapper">
                    <label for="DirectEmail">Direct Email</label>
                    <input
                      type="text"
                      className="form-control"
                      value={answers.DirectEmail}
                      onChange={(el) => {
                        setAnswer("DirectEmail", el.target.value);
                      }}
                    />
                  </div>
                  {/*City*/}
                  <div className="field-wrapper">
                    <label for="City">City</label>
                    <input
                      type="text"
                      className="form-control"
                      value={answers.City}
                      onChange={(el) => {
                        setAnswer("City", el.target.value);
                      }}
                    />
                  </div>
                  {/* State and Zip*/}
                  <div className="field-wrapper">
                    <div className="field-box2 field-ext">
                      <label for="State">State</label>
                      <select
                        className="form-control"
                        name="state"
                        value={answers.State}
                        onChange={(el) => {
                          setAnswer("State", el.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {stateCodeArray.map((el) => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="field-box1 field-ext">
                      <label for="state">Zip</label>
                      <input
                        className="form-control"
                        value={answers.Zip}
                        onChange={(el) => {
                          setAnswer("Zip", el.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <div className=" field-wrapper">
                    <div id="accordion" className="accordion">
                      <div className="card mb-0">
                        <div
                          className="card-header collapsed"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          href="#collapseThree"
                        ></div>
                        <div
                          id="collapseThree"
                          className="collapse"
                          data-parent="#accordion"
                        >
                          <div className="field-wrapper spacer-margin4">
                            <div className="ctr sub-titles spacer-margin7 blk-clr">
                              Specialty
                            </div>
                            <div className="text-reg spacer-margin7">
                              All three criteria must be selected to search by
                              Specialty.
                            </div>
                            <SpecialtyDropdown
                              SpecialFormFields={(el, val) =>
                                SpecialFormFields(el, val)
                              }
                            />

                            {/*Specialty Component */}
                            {/*<SpecialtyDropdown />*/}
                            <div className="text-reg">
                              Not all search criteria fields may be available
                              for each directory information source.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(el) => AdvSearchFunc()}
                >
                  Search
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {processing ? <div className="loading"></div> : null}
    </div>
  );
};

export default AdvSearch;
